import { render, staticRenderFns } from "./AppointmentCard.vue?vue&type=template&id=6422d0ce"
import script from "./AppointmentCard.vue?vue&type=script&lang=js"
export * from "./AppointmentCard.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCard.vue?vue&type=style&index=0&id=6422d0ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports